import formatAsCurrency from '../../CommonUtils/formatAsCurrency';

const DebtManagementAssumptions = [
  {
    title: 'Target Amount',
    key: 'TargetAmount',
    template: value => `${formatAsCurrency(value)}`,
  },
  {
    title: 'Target Year',
    key: 'TargetYear',
    template: value => value,
  },
  {
    title: 'Number of months of expenses this will cover',
    key: 'MonthsOfExpensesCovered',
    template: value => `${value} Months`,
  },
  {
    title: 'Earmarked Assets',
    key: 'EarmarkedAssets',
    template: value => `${formatAsCurrency(value)}`,
  },
];

export default DebtManagementAssumptions;
